import { c as _c } from "react/compiler-runtime";
import { getPassengersCountAboveTwoYearsOld } from "@website/accommodation-ui/helpers";
import { TourSolutionType } from "@website/accommodation-ui/types/tour/TourSolutionType";
import { useJwtToken } from "@website/hooks/auth-manager";
import { MaterialNameType } from "@website/icons/material";
import { addEventToDataLayer } from "@website/tracking/tracking.gtm";
import { DATA_LAYER_EVENTS, USER_TRACKING_EVENTS, WEBENGAGE_EVENTS } from "@website/tracking/tracking.types";
import { addEventToWebengage } from "@website/tracking/tracking.webengage";
import { addEventToTracking } from "@website/tracking/user";
import { daysBetweenDates } from "@website/utils/date-format";
import { numberConvert } from "@website/utils/number-convert";
import toString from "lodash-es/toString";
import { useRouter } from "next/router";
interface Properties {
  solutions: Array<TourSolutionType>;
  cityFromTitle: string;
  cityToTitle: string;
  hasFilter: boolean;
  adultsCount: number;
  childCount: number;
  rooms: Array<string>;
  passengers: Array<{
    adultCount: number;
    children: Array<number>;
  }>;
  params: {
    dest: string;
    search_source: string;
    source: string;
    stDate: string;
    rtDate: string;
    calendar_type: string;
    passengersParameter: string;
  };
}
export function useTransformToHotels(t0) {
  const $ = _c(34);
  const {
    solutions,
    cityFromTitle,
    cityToTitle,
    hasFilter,
    adultsCount,
    childCount,
    rooms,
    passengers,
    params: t1
  } = t0;
  const {
    dest,
    search_source,
    source,
    stDate,
    rtDate,
    calendar_type,
    passengersParameter
  } = t1;
  const {
    query
  } = useRouter();
  let t2;
  if ($[0] !== passengersParameter) {
    t2 = getPassengersCountAboveTwoYearsOld(passengersParameter) || 1;
    $[0] = passengersParameter;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const passengersAboveTwoYearsOldCount = t2;
  const {
    phoneNumber
  } = useJwtToken();
  let t3;
  if ($[2] !== adultsCount || $[3] !== calendar_type || $[4] !== childCount || $[5] !== cityFromTitle || $[6] !== cityToTitle || $[7] !== dest || $[8] !== hasFilter || $[9] !== passengers || $[10] !== phoneNumber || $[11] !== rooms?.length || $[12] !== rtDate || $[13] !== search_source || $[14] !== solutions || $[15] !== source || $[16] !== stDate) {
    t3 = t4 => {
      const {
        hotel,
        departureFlight,
        returningFlight,
        pricing,
        supplier
      } = t4;
      addEventToDataLayer(DATA_LAYER_EVENTS.HOTEL_SUCCEED, {
        item_brand: "tour",
        item_name: `${origin} - ${dest}`,
        hotel_name: hotel?.name,
        hotel_star: hotel?.stars,
        destination_city: dest,
        departure_date: departureFlight?.departureDateTime,
        origin_city: origin,
        number_of_passengers: passengers,
        search_window: Math.abs(daysBetweenDates(new Date(), departureFlight?.departureDateTime)),
        return_date: returningFlight?.departureDateTime,
        search_source,
        nightstay: Math.abs(daysBetweenDates(returningFlight?.arrivalDateTime, departureFlight?.departureDateTime)),
        price: pricing.price,
        number_of_results: solutions.length
      });
      addEventToWebengage(WEBENGAGE_EVENTS.TOUR_ST_HOTEL_SELECTED, {
        webengageData: {
          OriginCity: cityFromTitle,
          DestinationCity: cityToTitle,
          DepartureDate: stDate,
          ReturningDate: rtDate,
          AdultCount: adultsCount,
          ChildCount: childCount,
          ChildAge: passengers?.flatMap(_temp)?.join("-"),
          RoomCount: rooms?.length
        },
        HotelName: hotel.name,
        HotelStars: hotel.stars,
        RoomType: hotel.rooms?.map?.(_temp2).join("-"),
        OutboundFlightAirline: returningFlight?.airline,
        InboundFlightAirline: departureFlight?.airline,
        OutboundDepartureDate: returningFlight?.arrivalDateTime,
        InboundDepartureDate: departureFlight?.arrivalDateTime,
        ProviderDiscountNumber: pricing.price - pricing.priceOff,
        TotalPrice: pricing.priceOff,
        UserPhoneNumber: phoneNumber,
        Source: source,
        HasFilter: hasFilter,
        Sort: "",
        TourProvider: supplier?.name
      });
      addEventToTracking(USER_TRACKING_EVENTS.TOUR_HOTEL_SELECT_CLICKED, {
        product: "tour",
        origin_city: origin,
        destination_city: dest,
        departure_date: new Date(departureFlight?.departureDateTime),
        arrival_date: new Date(departureFlight?.arrivalDateTime),
        return_departure_date: new Date(returningFlight?.departureDateTime),
        return_arrival_date: new Date(returningFlight?.arrivalDateTime),
        number_of_passengers: adultsCount + childCount,
        number_of_rooms: hotel?.rooms?.length,
        search_window: Math.abs(daysBetweenDates(new Date(), departureFlight?.departureDateTime)),
        number_of_results: solutions.length,
        hotel_id: hotel.id,
        hotel_name: hotel?.name,
        outbound_flight_airline: departureFlight?.airline,
        inbound_flight_airline: returningFlight?.airline,
        total_price: pricing.priceOff,
        tour_provider: supplier?.name,
        tour_has_filters: hasFilter,
        hotel_stars: hotel.stars,
        calendar_type,
        room_type: hotel?.rooms?.map(_temp3)
      });
    };
    $[2] = adultsCount;
    $[3] = calendar_type;
    $[4] = childCount;
    $[5] = cityFromTitle;
    $[6] = cityToTitle;
    $[7] = dest;
    $[8] = hasFilter;
    $[9] = passengers;
    $[10] = phoneNumber;
    $[11] = rooms?.length;
    $[12] = rtDate;
    $[13] = search_source;
    $[14] = solutions;
    $[15] = source;
    $[16] = stDate;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  const handleSolutionEvents = t3;
  let t4;
  bb0: {
    if (!solutions) {
      let t5;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = [];
        $[18] = t5;
      } else {
        t5 = $[18];
      }
      t4 = t5;
      break bb0;
    }
    let t5;
    if ($[19] !== adultsCount || $[20] !== childCount || $[21] !== handleSolutionEvents || $[22] !== passengersAboveTwoYearsOldCount || $[23] !== query || $[24] !== solutions) {
      let t6;
      if ($[26] !== adultsCount || $[27] !== childCount || $[28] !== handleSolutionEvents || $[29] !== passengersAboveTwoYearsOldCount || $[30] !== query) {
        t6 = (sl, index) => {
          const {
            price,
            priceOff
          } = sl.pricing;
          const title = `قیمت ${numberConvert(1, {
            locale: "fa"
          })} نفر (بلیط + اقامت) از`;
          const partnershipBadge = sl.badges?.find(_temp4);
          const isFlight = sl?.departureFlight?.transportType === "FLIGHT";
          const transportationIcon = isFlight ? "flight" : "train";
          return {
            id: sl.hotel?.id || -1,
            hotelDetail: {
              cityId: -1,
              hotelId: sl?.hotel?.id,
              hotelTitle: sl.hotel?.name || "",
              stars: sl.hotel?.stars || 0,
              rating: sl.hotel?.rating || 0,
              reviewCount: sl?.hotel?.reviewCount || 0,
              isAvailable: true,
              address: sl.hotel.address?.split(/[,،]/).map(_temp5).slice(0, 2).join("\u060C ") ?? "",
              roomTitle: title,
              hotelPageUrl: {
                pathname: "/[origin]/[dest]/[id]",
                query: {
                  ...query,
                  id: sl.searchId.toString(),
                  hotelId: sl.hotel?.id.toString(),
                  isDomestic: sl.isDomestic ? "true" : "false",
                  tour_position_rank: index + 1
                }
              }
            },
            isInternational: !sl.isDomestic,
            gallery: sl.hotel?.gallery?.map(_temp6) || [],
            thumbnail: {
              url: sl.hotel?.thumbnails?.[0].src || "",
              alt: sl.hotel?.thumbnails?.[0].title || ""
            },
            pricing: {
              price: Number((price / (passengersAboveTwoYearsOldCount * 10)).toFixed(0)) || 0,
              priceOff: Number((priceOff / (passengersAboveTwoYearsOldCount * 10)).toFixed(0)) || 0,
              discountPercentage: sl.pricing?.discountPercent
            },
            regularBadges: sl.badges?.filter(_temp7)?.map(_temp8) ?? [],
            primaryBadge: {
              icon: "celebration" as const,
              color: "white",
              text: toString(partnershipBadge?.title),
              description: toString(partnershipBadge?.description),
              transparent: false
            },
            transportation: {
              icons: [transportationIcon],
              text: isFlight ? "\u0634\u0627\u0645\u0644 \u067E\u0631\u0648\u0627\u0632 \u0631\u0641\u062A \u0648 \u0628\u0631\u06AF\u0634\u062A" : "\u0634\u0627\u0645\u0644 \u0642\u0637\u0627\u0631 \u0631\u0641\u062A \u0648 \u0628\u0631\u06AF\u0634\u062A"
            },
            reservationInfo: {
              passengersCount: adultsCount + childCount,
              totalPrice: (priceOff || price) / 10
            },
            onLinkClick: () => handleSolutionEvents(sl)
          };
        };
        $[26] = adultsCount;
        $[27] = childCount;
        $[28] = handleSolutionEvents;
        $[29] = passengersAboveTwoYearsOldCount;
        $[30] = query;
        $[31] = t6;
      } else {
        t6 = $[31];
      }
      t5 = solutions.map(t6);
      $[19] = adultsCount;
      $[20] = childCount;
      $[21] = handleSolutionEvents;
      $[22] = passengersAboveTwoYearsOldCount;
      $[23] = query;
      $[24] = solutions;
      $[25] = t5;
    } else {
      t5 = $[25];
    }
    t4 = t5;
  }
  const hotelList = t4;
  let t5;
  if ($[32] !== hotelList) {
    t5 = {
      hotelList
    };
    $[32] = hotelList;
    $[33] = t5;
  } else {
    t5 = $[33];
  }
  return t5;
}
function _temp8(badge) {
  return {
    text: badge.title,
    color: badge.color || "#EBECF2"
  };
}
function _temp7(b_0) {
  return b_0.type !== "partnership";
}
function _temp6(image) {
  return {
    id: image?.src || "",
    title: image?.title || "",
    media: image?.src || ""
  };
}
function _temp5(part) {
  return part.trim();
}
function _temp4(b) {
  return b.type?.toLowerCase() === "partnership";
}
function _temp3(room_1) {
  return room_1?.roomTitle;
}
function _temp2(room_0) {
  return room_0?.roomTitle;
}
function _temp(room) {
  return room?.children;
}